/*
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-17 20:42:45
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-20 16:30:10
 */
export default [
	{
		path: "appList",
		name: "APP_LIST",
		meta: {
			title: "应用列表",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/app/appList.vue"),
	},
	{
		path: "wabAppContent",
		name: "WEB_APP_CONTENT",
		meta: {
			title: "应用详情",
			icon: "",
			isNav: true,
		},
		component: () => import("@views/app/wabAppContent.vue"),
	},
	{
		path: "vipAppContent",
		name: "VIP_APP_CONTENT",
		meta: {
			title: "应用-vip权益",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/app/vipAppContent.vue"),
	},
	{
		path: "webAppList",
		name: "WEB_APP_LIST",
		meta: {
			title: "应用列表",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@views/app/webAppList.vue"),
	},
	{
		path: "NavigationManagement",
		name: "NAVIGATION_MANAGEMENT",
		meta: {
			title: "导航管理",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/app/NavigationManagement.vue"),
	},
	{
		path: "appContent",
		name: "APP_CONTENT",
		meta: {
			title: "应用-内容",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/app/appContent.vue"),
	},

	{
		path: "appAdvertising",
		name: "APP_ADVERTISING",
		meta: {
			title: "应用-广告",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/app/appAdvertising.vue"),
	},
	{
		path: "appTestNav",
		name: "APP_TESTNAV",
		meta: {
			title: "测评导航",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/app/appTestNav.vue"),
	},
	{
		path: "appStyle",
		name: "APP_STYLE",
		meta: {
			title: "应用样式",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/app/appStyle.vue"),
	},
	{
		path: "keywordList",
		name: "KEYWORD_LIST",
		meta: {
			title: "关键字配置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/app/keywordList.vue"),
	},
];
